import * as Sentry from '@sentry/react';
import { getEnvironment } from 'utilities/environment';

window.Sq = window.Sq || {};
Sq.Shop = Sq.Shop || {};
Sq.Shop.ExceptionReporter = {
  utils: Sq.Shop.Utils,

  DSN: {
    // solidshop-fe
    production: 'https://5204f172ebe54d7bbe5b41a731cd17be@sentry.io/5778127',
    // solidshop-fe-staging
    staging: 'https://4dc1c56aff3641d3a23a53d683855546@sentry.io/5778133',
  },

  SENTRY_OPTIONS: {
    ignoreErrors: [
      // Random plugins/extensions
      'top.GLOBALS',
      // See: http://blog.errorception.com/2012/03/tale-of-unfindable-js-error.html
      'originalCreateNotification',
      'canvas.contentDocument',
      'MyApp_RemoveAllHighlights',
      'http://tt.epicplay.com',
      "Can't find variable: ZiteReader",
      'jigsaw is not defined',
      'ComboSearch is not defined',
      'http://loading.retry.widdit.com/',
      'atomicFindClose',
      // Facebook borked
      'fb_xd_fragment',
      // ISP "optimizing" proxy - `Cache-Control: no-transform` seems to
      // reduce this. (thanks @acdha)
      // See http://stackoverflow.com/questions/4113268
      'bmi_SafeAddOnload',
      'EBCallBackMessageReceived',
      // See http://toolbar.conduit.com/Developer/HtmlAndGadget/Methods/JSInjection.aspx
      'conduitPage',
    ],
    denyUrls: [
      // Facebook flakiness
      /graph\.facebook\.com/i,
      // Facebook blocked
      /connect\.facebook\.net\/en_us\/all\.js/i,
      // Woopra flakiness
      /eatdifferent\.com\.woopra-ns\.com/i,
      /static\.woopra\.com\/js\/woopra\.js/i,
      // Chrome extensions
      /extensions\//i,
      /^chrome:\/\//i,
      // Other plugins
      /127\.0\.0\.1:4001\/isrunning/i, // Cacaoweb
      /webappstoolbarba\.texthelp\.com\//i,
      /metrics\.itunes\.apple\.com\.edgesuite\.net\//i,
    ],
    beforeSend: (event) => {
      if (!Sq.OneTrust || Sq.OneTrust.analyticsTrackingEnabled) {
        return event;
      }

      return null;
    },
  },

  init() {
    const envConfig = getEnvironment();
    if (envConfig) {
      Sentry.init({
        ...this.SENTRY_OPTIONS,
        dsn: this.DSN[envConfig.env],
        environment: envConfig.env,
      });

      Sentry.configureScope((scope) => {
        scope.setContext('diagnostics', this.utils.diagnosticData());
      });
    }
  },

  capture(err) {
    if (err instanceof Error) {
      Sentry.captureException(err);
    } else {
      Sentry.captureMessage(err);
    }
  },
};

Sq.Shop.ExceptionReporter.init();

export default Sq.Shop.ExceptionReporter;
